import { types } from 'mobx-state-tree';
import createInstanceCache from './InstanceCache';
var createLocalEntityProvider = function (modelType) {
    var InstanceCache = createInstanceCache(modelType);
    return types.model({ instanceCache: types.optional(InstanceCache, function () { return InstanceCache.create(); }) })
        .named(modelType.name + "LocalEntityProvider")
        .views(function (self) { return ({
        get: function (id) {
            // try to get from instance cache
            var cachedInstance = self.instanceCache.get(id);
            if (cachedInstance) {
                return cachedInstance;
            }
            // self.env.database.get(id);
            // if undefined => return undefined
            // else
            // add to cache
            // return entity
            // ToDo: remove
            return undefined;
        },
        getMany: function (ids) {
            // try to get from instance cache
            var cachedInstances = self.instanceCache.getMany(ids);
            if (cachedInstances.length) {
                return cachedInstances;
            }
            // self.env.database.get(id);
            // if undefined => return undefined
            // else
            // add to cache
            // return entity
            // ToDo: remove
            return [];
        }
    }); })
        .actions(function (self) { return ({
        addOrApplySnapshot: function (snapshot) {
            self.instanceCache.addOrApplySnapshot(snapshot);
        },
        delete: function (id) {
            self.instanceCache.delete(id);
        },
        deleteAll: function () {
            self.instanceCache.deleteAll();
        }
    }); });
};
export default createLocalEntityProvider;
//# sourceMappingURL=LocalEntityProvider.js.map